import { TextField } from '@mui/material'
import prefStyles from '@/components/Settings/SettingsPreferenceSection.module.scss'

/**
 * @param {{
 *   'aria-label': string,
 *   value: string,
 *   onChange: (value: string) => void,
 *   placeholder?: string,
 *   autoFocus?: boolean,
 *   onKeyDown?: (event: import('react').KeyboardEvent) => void,
 *   className?: string,
 * }} props
 */
export function PreferenceTextInput({
  'aria-label': ariaLabel,
  value,
  onChange,
  placeholder,
  autoFocus,
  onKeyDown,
  className,
}) {
  return (
    <TextField
      size="small"
      variant="outlined"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      autoFocus={autoFocus}
      onKeyDown={onKeyDown}
      inputProps={{ 'aria-label': ariaLabel }}
      className={className ? `${prefStyles.textField} ${className}` : prefStyles.textField}
    />
  )
}
